export const userRender = (e) => {
    const user = e.data.user;
    return `${user.firstName} ${user.lastName}`;
};
